import React from 'react';

import { Typography, Box } from 'vindi-ds-components';
import { VdCheckmarkCircleFill } from 'vindi-ds-icons/vd';

import styles from './styles';

function AdvertsInfo({ title, children }) {
  return (
    <Box style={styles.advertsInfoBox}>
      <Box display='flex' justifyContent='flex-start' style={styles.iconBox}>
        <VdCheckmarkCircleFill style={styles.checkCircleIcon} />
      </Box>
      <Box>
        <Box style={styles.infoBox}>
          <Typography variant='h5'>{title}</Typography>
        </Box>
        <Typography variant='body2'>{children}</Typography>
      </Box>
    </Box>
  );
}

export default AdvertsInfo;
